import { FINANCIAL_PRODUCT } from '@utils/constants';

export enum AnalyticsEvent {
  SignedIn = 'Signed In',
  ViewedPackage = 'Viewed Package',
  SelectedPackage = 'Selected Package Category',
  SubmittedCustomerPackage = 'Submitted Customer Package',
  SubmittedCustomerPackageCategory = 'Submitted Customer Package Category',
}

export enum AnalyticsPage {
  PackageCategoryQuotes = 'Package Category Quotes',
  PackageCategories = 'Package Categories',
  PackagePaymentSummary = 'Package Summary',
}

export const CUSTOMER_CONNECT_SOURCE = 'Customer Connect';

export const ANALYTICS_CHANNEL: Record<string, string> = {
  [FINANCIAL_PRODUCT.ELECTRIFY_2515]: 'electrify-2515',
  [FINANCIAL_PRODUCT.CBA_RESIDENTIAL]: 'commbank',
};
